var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "search_item" }, [
    _c("a", { staticClass: "search_link", attrs: { href: _vm.linkUrl } }, [
      _vm.article.thumbnailUrl
        ? _c("span", { staticClass: "search_thumbnail_wrapper" }, [
            _c("img", {
              staticClass: "search_thumbnail_img",
              attrs: {
                src: _vm.article.thumbnailUrl,
                width: "52",
                height: "52",
                alt: "게시글 이미지"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "search_content" }, [
        _c("strong", {
          staticClass: "search_title",
          domProps: { innerHTML: _vm._s(_vm.article.content) }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "search_date" }, [
          _c("span", [_vm._v(_vm._s(_vm.article.regdttm))]),
          _vm._v(" "),
          _c("span", { staticClass: "search_dot" }),
          _vm._v(" "),
          _c("span", [
            _vm._v("댓글 " + _vm._s(_vm.article.commentCount.toLocaleString()))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }